import Vue from 'vue'
import Vuex from 'vuex'

import texts from './texts'
import dropdowns from './dropdowns'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    form: {
      car: {
        model: {
          value: "",
          name: "Novi Xtrail",
          image: "",
        },
        vin: "",
        year: ""
      },
      user: {
        title: '',
        name: '',
        last_name: '',
        email: '',
        //phone: ''
      },
      /*gdpr: {
        //eNews: false,
        //purchase: ''
        emailNotice: false,
        phoneNotice: false,
        smsNotice: false
      }*/
      formName: "LF-N-OstaniteSaNama-Nissan-Xtrail"
    },
    // VALIDATION
    validation: {
      title: false,
      name: false,
      lastName: false,
      email: false,
      //phone: true
    },
    buttons: {
      /*purchase: {
        value: null,
        error: false
      }*/
      emailNotice: {
        value: null,
        error: false
      },
      /*phoneNotice: {
        value: null,
        error: false
      },
      smsNotice: {
        value: null,
        error: false
      }*/
    },
    submitted: false,
    DisclosureOneOpened: false
  },
  getters: {
    name: state => {
      return state.form.user.name
    },
    last_name: state => {
      return state.form.user.last_name
    },
    email: state => {
      return state.form.user.email
    },
    /*phone: state => {
      return state.form.user.phone
    },*/
  },
  mutations: {
    updateName: (state, data) => {
      state.form.user.name = data
    },
    updateLastName: (state, data) => {
      state.form.user.last_name = data
    },
    updateEmail: (state, data) => {
      state.form.user.email = data
    },
    /*updatePhone: (state, data) => {
      state.form.user.phone = data
    },*/
  },
  modules: {
    dropdowns,
    texts
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js